import * as types from '../constants/ActionTypes.js';
import { ROOT_URL } from '../constants/Config.js';

import axios from 'axios';
import { gaEvent, trackGA } from 'services/ga.js';

const handleTrackEvent = ({
  eventName,
  eventLabel,
  buildingId,
  buildingName,
  profileId,
  objectType,
}) => {
  trackGA(
    gaEvent[eventName]({
      eventLabel,
      eventContent: buildingName,
      productType: objectType || '',
      productName: buildingName || '',
      productID: buildingId || '',
      user_id: profileId,
    })
  );
};

export function loadFavorites(data) {
  return (dispatch) => {
    dispatch({ type: types.LOAD_FAVORITES_START });
    return axios
      .get(`${ROOT_URL}/favorite/lists`, { params: data })
      .then((res) => {
        dispatch({ type: types.LOAD_FAVORITES_SUCCESS, payload: res.data });
      })
      .catch((error) => {
        dispatch({ type: types.LOAD_FAVORITES_ERROR, payload: { error } });
      });
  };
}

export function addToFavorites(data, meta) {
  return (dispatch) => {
    dispatch({ type: types.ADD_TO_FAVORITES_START });
    return axios
      .post(`${ROOT_URL}/favorite/create`, data)
      .then((res) => {
        dispatch({ type: types.ADD_TO_FAVORITES_SUCCESS, payload: data, meta });
        if (meta.eventLocation === 'favorites') {
          handleTrackEvent({
            eventName: 'favoritesAddAndDeleteBuildingResult',
            eventLabel: 'dobavlen_v_izbrannoe',
            buildingName: meta.buildingName,
            profileId: meta.profileId,
          });
        } else {
          handleTrackEvent({
            eventName: 'buildingFavoritesResult',
            eventLabel: 'dobavlen_v_izbrannoe',
            buildingId: data.buildingId,
            buildingName: meta.buildingName,
            profileId: meta.profileId,
            objectType: meta.data.type_id === 1 ? 'zhk' : 'kp_i_th',
          });
        }
      })
      .catch((error) => {
        dispatch({ type: types.ADD_TO_FAVORITES_ERROR, payload: error });
      });
  };
}

export function removeFromFavorites(data, meta = {}) {
  return (dispatch) => {
    dispatch({ type: types.REMOVE_FROM_FAVORITES_START });
    return axios
      .post(`${ROOT_URL}/favorite/delete`, data)
      .then((res) => {
        dispatch({
          type: types.REMOVE_FROM_FAVORITES_SUCCESS,
          payload: data,
          meta: Object.assign(meta, { cancel: addToFavorites.bind(null, data, meta) }),
        });
        if (meta.eventLocation === 'favorites') {
          handleTrackEvent({
            eventName: 'favoritesAddAndDeleteBuildingResult',
            eventLabel: 'udalen_iz_izbrannogo',
            buildingName: meta.buildingName,
            profileId: meta.profileId,
          });
        } else {
          handleTrackEvent({
            eventName: 'buildingFavoritesResult',
            eventLabel: 'ubran_iz_izbrannogo',
            buildingId: data.buildingId,
            buildingName: meta.buildingName,
            profileId: meta.profileId,
            objectType: meta.data.type_id === 1 ? 'zhk' : 'kp_i_th',
          });
        }
      })
      .catch((error) => {
        dispatch({ type: types.REMOVE_FROM_FAVORITES_ERROR, payload: error });
      });
  };
}



// WEBPACK FOOTER //
// ./src/actions/favorites.js